import { segmentsTracking } from 'src/common/lib/tracker';
import { Button } from 'carbon-components-react';
import { Restart32 } from '@carbon/icons-react';

import messages from '../../locales/messages';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';
import { FigmaDemo } from '../../constants/defaults';
import { readBucket } from 'src/common/utils/readCOS';
import { LangDefaults } from 'src/common/hooks/widgets/useLang';

const pageTitle = 'IBM Cognos Analytics';

export interface UseCase1Props {
  bpName: string;
  setShowOption: React.Dispatch<React.SetStateAction<number>>;
  lang: string;
}

const UseCase1 = ({ bpName, setShowOption, lang }: UseCase1Props) => {
  const [response] = readBucket(FigmaDemo);
  const [demo, setDemo] = useState(``);

  // Determine Figma Demo content to show
  useEffect(() => {
    response.map((obj) => {
      if (obj.countryLang === lang) {
        setDemo(obj.emailDemoUrl);
        return obj;
      }
    });
    if (demo.length === 0) {
      response.map((obj) => {
        if (obj.countryLang === LangDefaults.localCountryLang) {
          setDemo(obj.emailDemoUrl);
          return obj;
        }
      });
    }
  }, [response, lang, demo]);

  useEffect(() => {
    const frameId = document.getElementById('figma_demo1');
    const figmaAction = (action: string) => {
      segmentsTracking('CTA Clicked', {
        pageTitle,
        object: 'IFrame content Demo1',
        resultValue: action,
        CTA: 'Mouse moved',
        location: 'Demo',
        action: 'Moved over the demo content',
        field: '',
      });
    };

    const addListener = (id: HTMLElement | null) => {
      if (id === null) {
        return;
      }
      id.addEventListener('mouseover', (e) => {
        if (e === null) {
          return;
        }
        figmaAction('Enter Iframe');
        const element = e.currentTarget as HTMLInputElement;
        if (element.value === '') {
          return;
        }
      });
      id.addEventListener('mouseout', (e) => {
        if (e === null) {
          return;
        }
        figmaAction('Exit Iframe');
        const element = e.currentTarget as HTMLInputElement;
        if (element.value === '') {
          return;
        }
      });
    };
    /**
     * Iframe Listener
     */
    addListener(frameId);
  }, []);

  return (
    <div>
      <div className="bx--grid content1-page">
        <div className="bx--row section">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <Button
              renderIcon={Restart32}
              className="button-header button-header2 mar1"
              kind="tertiary"
              onClick={() => {
                segmentsTracking('CTA Clicked', {
                  pageTitle: pageTitle,
                  object: 'Home page',
                  resultValue: 'CTA clicked',
                  CTA: 'Request to go the home page',
                  location: 'Demo',
                  action: 'Clicked',
                  field: '',
                });
                setShowOption(0);
              }}
            >
              <FormattedMessage {...messages.home_button} />
            </Button>
          </div>
        </div>
        <div className="bx--row section">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <div className="demo">
              {bpName ? (
                <>
                  <div className="bx--row figma_top">
                    <div className="bx--col"></div>
                  </div>
                </>
              ) : (
                <div className="bx--row"></div>
              )}
              <div className="bx--row">
                <iframe
                  tabIndex={-1}
                  onLoad={() => {
                    window.parent.focus();
                  }}
                  className="figma_frame"
                  title="Cognos Analytics Demo"
                  id="figma_demo1"
                  src={demo}
                ></iframe>
              </div>
              <div className="bx--row">
                <div className="bx--col figma_bottom1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UseCase1;
